export const memberList = [
  { name: "car", color: "crimson" },
  { name: "cat", color: "teal" },
  { name: "dino", color: "darkGreen" },
  { name: "duck", color: "orangeRed" },
  { name: "hat", color: "saddleBrown" },
  { name: "penguin", color: "purple" },
  { name: "ship", color: "navy" },
  { name: "Bank", color: "darkSlateGray" },
];
export const bank = {
  name: "Bank",
  id: "Bank",
  bankroll: 10000,
};
export const initialTransaction = {
  payer: "Bank",
  receiver: "Bank",
  sum: 10000,
};
export const propertyList = [
  //BROWN
  {
    name: "MEDITERRANEAN AVENUE",
    payments: [
      60, 2, 30, 33, 4, 10, 30, 90, 160, 250, 50, 100, 150, 200, 250, 25, 50,
      75, 100, 125,
    ],
    color: "brown",
  },
  {
    name: "BALTIC AVENUE",
    payments: [
      60, 4, 30, 33, 8, 20, 60, 180, 320, 450, 50, 100, 150, 200, 250, 25, 50,
      75, 100, 125,
    ],
    color: "brown",
  },
  //RAILROAD#1
  {
    name: "READING RAILROAD",
    payments: [
      200, 25, 100, 110, 0, 0, 50, 100, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    color: "white",
  },
  //POWDERBLUE
  {
    name: "ORIENTAL AVENUE",
    payments: [
      100, 6, 50, 55, 12, 30, 90, 270, 400, 550, 50, 100, 150, 200, 250, 25, 50,
      75, 100, 125,
    ],
    color: "powderBlue",
  },
  {
    name: "VERMONT AVENUE",
    payments: [
      100, 6, 50, 55, 12, 30, 90, 270, 400, 550, 50, 100, 150, 200, 250, 25, 50,
      75, 100, 125,
    ],
    color: "powderBlue",
  },
  {
    name: "CONNECTICUT AVENUE",
    payments: [
      120, 8, 60, 66, 16, 40, 100, 300, 450, 600, 50, 100, 150, 200, 250, 25,
      50, 75, 100, 125,
    ],
    color: "powderBlue",
  },
  //PINK
  {
    name: "ST. CHARLES PLACE",
    payments: [
      140, 10, 70, 77, 20, 50, 150, 450, 625, 750, 100, 200, 300, 400, 500, 50,
      100, 150, 200, 250,
    ],
    color: "pink",
  },
  //ELECTRIC COMPANY
  {
    name: "ELECTRIC COMPANY",
    payments: [150, 0, 75, 83, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    color: "white",
  },
  {
    name: "STATES AVENUE",
    payments: [
      140, 10, 70, 77, 20, 50, 150, 450, 625, 750, 100, 200, 300, 400, 500, 50,
      100, 150, 200, 250,
    ],
    color: "pink",
  },
  {
    name: "VIRGINIA AVENUE",
    payments: [
      160, 12, 80, 88, 24, 60, 180, 500, 700, 900, 100, 200, 300, 400, 500, 50,
      100, 150, 200, 250,
    ],
    color: "pink",
  },
  //RAILROAD#2
  {
    name: "PENNSYLVANIA RAILROAD",
    payments: [
      200, 25, 100, 110, 0, 0, 50, 100, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    color: "white",
  },
  //ORANGE
  {
    name: "ST. JAMES PLACE",
    payments: [
      180, 14, 90, 99, 28, 70, 200, 550, 750, 950, 100, 200, 300, 400, 500, 50,
      100, 150, 200, 250,
    ],
    color: "orange",
  },
  {
    name: "TENNESSEE AVENUE",
    payments: [
      180, 14, 90, 99, 28, 70, 200, 550, 750, 950, 100, 200, 300, 400, 500, 50,
      100, 150, 200, 250,
    ],
    color: "orange",
  },
  {
    name: "NEW YORK AVENUE",
    payments: [
      200, 16, 100, 110, 32, 80, 220, 600, 800, 1000, 100, 200, 300, 400, 500,
      50, 100, 150, 200, 250,
    ],
    color: "orange",
  },
  //RED
  {
    name: "KENTUCKY AVENUE",
    payments: [
      220, 18, 110, 121, 36, 90, 250, 700, 875, 1050, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "tomato",
  },
  {
    name: "INDIANA AVENUE",
    payments: [
      220, 18, 110, 121, 36, 90, 250, 700, 875, 1050, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "tomato",
  },
  {
    name: "ILLINOIS AVENUE",
    payments: [
      240, 20, 120, 132, 40, 100, 300, 750, 925, 1100, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "tomato",
  },
  //RAILROAD#3
  {
    name: "B. & O. RAILROAD",
    payments: [
      200, 25, 100, 110, 0, 0, 50, 100, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    color: "white",
  },
  //YELLOW
  {
    name: "ATLANTIC AVENUE",
    payments: [
      260, 22, 130, 143, 44, 110, 330, 800, 975, 1150, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "yellow",
  },
  {
    name: "VENTNOR AVENUE",
    payments: [
      260, 22, 130, 143, 44, 110, 330, 800, 975, 1150, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "yellow",
  },
  //WATER WORKS
  {
    name: "WATER WORKS",
    payments: [150, 0, 75, 83, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    color: "white",
  },
  {
    name: "MARVIN GARDENS",
    payments: [
      280, 24, 140, 154, 48, 120, 360, 850, 1025, 1200, 150, 300, 450, 600, 750,
      75, 150, 225, 300, 375,
    ],
    color: "yellow",
  },
  //GREEN
  {
    name: "PACIFIC AVENUE",
    payments: [
      300, 26, 150, 165, 52, 130, 390, 900, 1100, 1275, 200, 400, 600, 800,
      1000, 100, 200, 300, 400, 500,
    ],
    color: "green",
  },
  {
    name: "NORTH CAROLINE AVENUE",
    payments: [
      300, 26, 150, 165, 52, 130, 390, 900, 1100, 1275, 200, 400, 600, 800,
      1000, 100, 200, 300, 400, 500,
    ],
    color: "green",
  },
  {
    name: "PENNSYLVANIA AVENUE",
    payments: [
      320, 28, 160, 176, 56, 150, 450, 1000, 1200, 1400, 200, 400, 600, 800,
      1000, 100, 200, 300, 400, 500,
    ],
    color: "green",
  },
  //RAILROAD#4
  {
    name: "SHORT LINE",
    payments: [
      200, 25, 100, 110, 0, 0, 50, 100, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    color: "white",
  },
  //BLUE
  {
    name: "PARK PLACE",
    payments: [
      350, 35, 175, 193, 70, 175, 500, 1100, 1300, 1500, 200, 400, 600, 800,
      1000, 100, 200, 300, 400, 500,
    ],
    color: "skyBlue",
  },
  {
    name: "BOARDWALK",
    payments: [
      400, 50, 200, 220, 100, 200, 600, 1400, 1700, 2000, 200, 400, 600, 800,
      1000, 100, 200, 300, 400, 500,
    ],
    color: "skyBlue",
  },
];
export const paymentsList = [
  { name: "price" },
  { name: "rent" },
  { name: "mortage" },
  { name: "unmortage" },
  { name: "rent with set" },
  { name: "1 house rent" },
  { name: "2 houses rent" },
  { name: "3 houses rent" },
  { name: "4 houses rent" },
  { name: "hotel rent" },
  { name: "buy 1 house" },
  { name: "buy 2 houses" },
  { name: "buy 3 houses" },
  { name: "buy 4 houses" },
  { name: "buy hotel" },
  { name: "demolish 1 house" },
  { name: "demolish 2 houses" },
  { name: "demolish 3 houses" },
  { name: "demolish 4 houses" },
  { name: "demolish hotel" },
];
